module.exports = __webpack_public_path__ + "static/2020-PLOS-a6cadae4215efaa125186a1aa3ea98c5.pdf";